var _defs, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 682.67 682.67",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 512h512v-512h-512z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 512h512v-512h-512z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 512h512v-512h-512z"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 682.67)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(392,128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v64h-64v-64",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-32",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(392,128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-32",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(328,128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-32",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(424,64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v64h-128v-64",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-64",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(136,272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h320v-208",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(256,384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(88,352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h416",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 15
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200,320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-112",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-288",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 15
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(136,208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h64l64-64v-80",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-128",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-168",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h136v-224",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h136",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(232,64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-17.673-14.327-32-32-32s-32 14.327-32 32 14.327 32 32 32 32-14.327 32-32z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32,96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h80",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(152,120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h32",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-136h-272",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88,288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v64l208 128 208-128v-136",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(136,240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h320",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWms);
export default __webpack_public_path__ + "static/media/wms.23965fcf485e78d0708998c81c729a0d.svg";
export { ForwardRef as ReactComponent };